import { __decorate } from "tslib";
import Vue from 'vue';
import Component from 'vue-class-component';
import TasksList from "@/components/Tasks/TasksListComponent.vue";
import { Prop, Watch } from 'vue-property-decorator';
import { mapActions, mapState } from 'vuex';
let CustomerTasks = class CustomerTasks extends Vue {
    customerId;
    tasks = [];
    fetchTasks;
    currentPage = 1;
    perPage = 20;
    totalRows = 0;
    isLoading;
    mounted() {
        this.refreshData();
    }
    refreshData() {
        this.tasks = [];
        this.fetchTasks({
            query: {
                customerId: this.customerId,
                $sort: { createdAt: -1 },
                $limit: this.perPage,
                $skip: (this.currentPage - 1) * this.perPage,
            }
        }).then(data => {
            this.tasks = data.data;
            this.totalRows = data.total;
        });
    }
};
__decorate([
    Prop(String)
], CustomerTasks.prototype, "customerId", void 0);
__decorate([
    Watch('currentPage')
], CustomerTasks.prototype, "refreshData", null);
CustomerTasks = __decorate([
    Component({
        name: 'customer-tasks',
        methods: {
            ...mapActions('tasks', { fetchTasks: 'find' }),
        },
        components: {
            TasksList,
        },
        computed: {
            ...mapState('tasks', { isLoading: 'isFindPending' })
        }
    })
], CustomerTasks);
export default CustomerTasks;
